/* product.js — Seafresh Trading product detail (buy) page.
   Data-driven: /pages/product-detail?id=<slug> renders from PRODUCTS below. */

const CDN = 'https://seafreshtrading.com/cdn/shop';

const PRODUCTS = {
  'vannamei-white-shrimp': {
    category: 'Shrimp',
    name: 'Fresh Frozen Vannamei White Shrimp',
    badge: { text: 'Best Seller' },
    images: [
      `${CDN}/products/WhiteShrimp1copy.png?v=1665880997&width=800`,
      `${CDN}/products/white.jpg?v=1665880996&width=800`,
      `${CDN}/products/WhiteShrimp2copy.png?v=1665880997&width=800`,
    ],
    desc: 'Our flagship product. Sourced directly from trusted farms in India, these Vannamei White Shrimp are available in multiple grades and sizes. Flash frozen immediately after harvest for maximum freshness. Packed in Nature Fresh branded boxes under QC supervision.',
    pack: [
      { label: 'Pack Size', value: '10 × 2 lb bags' },
      { label: 'Net Weight', value: '20 lb / case' },
      { label: 'Count Sizes', value: '16/20 · 21/25 · 26/30 · 31/40' },
    ],
    priceNote: 'Wholesale pricing available on request — minimum pallet orders',
    specs: [
      { label: 'Origin', value: 'India' },
      { label: 'Processing', value: 'IQF (Individually Quick Frozen)' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'peeled-deveined-tail-off': {
    category: 'Shrimp',
    name: 'Peeled & Deveined Vannamei White Shrimp — Tail Off',
    badge: { text: 'Popular' },
    images: [
      `${CDN}/products/PeeledandDeveinedTailoff.png?v=1665880230&width=800`,
      `${CDN}/products/tailoff.png?v=1665880230&width=800`,
    ],
    desc: 'Convenient ready-to-cook format. Peeled, deveined and tail removed for ease of use in commercial kitchens, food processing, and retail. Sourced from India, IQF frozen.',
    pack: [
      { label: 'Pack Size', value: '10 × 2 lb bags' },
      { label: 'Net Weight', value: '20 lb / case' },
      { label: 'Count Sizes', value: '21/25 · 26/30 · 31/40 · 41/50' },
    ],
    priceNote: 'Wholesale pricing available on request — minimum pallet orders',
    specs: [
      { label: 'Origin', value: 'India' },
      { label: 'Processing', value: 'Peeled, Deveined, Tail Off, IQF' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'easy-peel': {
    category: 'Shrimp',
    name: 'Fresh Frozen Vannamei White Shrimp — Easy Peel',
    images: [
      `${CDN}/products/FreshFrozenWhtShrimpEasyPeelcopy.png?v=1665885118&width=800`,
      `${CDN}/products/easypeel.jpg?v=1665885118&width=800`,
    ],
    desc: 'Shell-on with a split shell for easy peeling. Popular with restaurants and seafood retailers who want the presentation benefits of shell-on shrimp with the convenience of quick peeling.',
    pack: [
      { label: 'Pack Size', value: '10 × 1 lb bags' },
      { label: 'Net Weight', value: '10 lb / case' },
      { label: 'Count Sizes', value: '26/30 · 31/40 · 41/50' },
    ],
    priceNote: 'Wholesale pricing available on request — minimum pallet orders',
    specs: [
      { label: 'Origin', value: 'India' },
      { label: 'Processing', value: 'Easy Peel, IQF' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'headless-shell-on': {
    category: 'Shrimp',
    name: 'Fresh Frozen Vannamei White Shrimp — Headless Shell-On',
    images: [
      `${CDN}/products/headlessshellon.png?v=1665881958&width=800`,
      `${CDN}/products/shellon2.jpg?v=1665881958&width=800`,
      `${CDN}/products/shellon.jpg?v=1665881958&width=800`,
    ],
    desc: 'Headless shell-on format. A versatile and popular choice for restaurants and seafood processors. Maintains excellent texture and flavour when cooked in shell.',
    pack: [
      { label: 'Pack Size', value: '6 × 4 lb bags' },
      { label: 'Net Weight', value: '24 lb / case' },
      { label: 'Count Sizes', value: '16/20 · 21/25 · 26/30 · 31/40' },
    ],
    priceNote: 'Wholesale pricing available on request — minimum pallet orders',
    specs: [
      { label: 'Origin', value: 'India' },
      { label: 'Processing', value: 'Headless Shell-On, IQF' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'cooked-pd-tail-on': {
    category: 'Shrimp',
    name: 'Frozen Cooked Peeled & Deveined Vannamei White Shrimp — Tail On',
    images: [
      `${CDN}/products/webimagessquare.png?v=1665891635&width=800`,
      `${CDN}/products/cedb65a3-c3a7-4c8d-aa7b-4d9cefb4cc50.jpg?v=1665891635&width=800`,
      `${CDN}/products/FreshWaterShrimp2copy_237c682b-985a-4193-b8b5-297b834da89a.png?v=1665891635&width=800`,
    ],
    desc: 'Pre-cooked, peeled and deveined with tail on. Ready to serve with minimal preparation. Ideal for shrimp cocktail, salads, and quick-serve applications.',
    pack: [
      { label: 'Pack Size', value: '10 × 2 lb bags' },
      { label: 'Net Weight', value: '20 lb / case' },
      { label: 'Count Sizes', value: '21/25 · 31/40 · 41/50' },
    ],
    priceNote: 'Wholesale pricing available on request — minimum pallet orders',
    specs: [
      { label: 'Origin', value: 'India' },
      { label: 'Processing', value: 'Cooked, Peeled, Deveined, Tail On, IQF' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'blue-swimming-crab': {
    category: 'Crab',
    name: 'Blue Swimming Crab Section w/ Claw',
    badge: { text: 'Premium', gold: true },
    images: [
      `${CDN}/products/Crab1copy.png?v=1665880720&width=800`,
      `${CDN}/products/crab.jpg?v=1665880721&width=800`,
      `${CDN}/products/Crab2copy.png?v=1665880720&width=800`,
    ],
    desc: 'Wild caught blue swimming crab sections with claw. IQF frozen for maximum freshness and texture. A high-demand product for seafood restaurants and retailers across California.',
    pack: [
      { label: 'Pack Size', value: '6 × 2 lb trays' },
      { label: 'Net Weight', value: '12 lb / case' },
      { label: 'Pricing', value: 'Contact for Quote' },
    ],
    priceNote: 'Wholesale pricing available on request — minimum pallet orders',
    specs: [
      { label: 'Origin', value: 'Mexico' },
      { label: 'Processing', value: 'Section with Claw, IQF' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'king-crab-claw': {
    category: 'Crab',
    name: 'King Crab Claw',
    badge: { text: 'Premium', gold: true },
    images: [
      `${CDN}/products/KingCrabLow.jpg?v=1665882792&width=800`,
      `${CDN}/products/KingCrabclaw2.jpg?v=1665882792&width=800`,
      `${CDN}/products/KingCrabclaw1.jpg?v=1665882792&width=800`,
    ],
    desc: 'Premium king crab claws sourced from cold Canadian waters. Wild caught, flash frozen, and delivered consistently. High-value product for fine dining restaurants and premium seafood retailers.',
    pack: [
      { label: 'Pack Size', value: '1 × 10 lb cluster' },
      { label: 'Net Weight', value: '10 lb / case' },
      { label: 'Pricing', value: 'Contact for Quote' },
    ],
    priceNote: 'Wholesale pricing available on request — premium seasonal product',
    specs: [
      { label: 'Origin', value: 'Canada' },
      { label: 'Processing', value: 'Wild Caught, IQF' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'tilapia-fillet': {
    category: 'Fish',
    name: 'Farm Raised Tilapia Fillet',
    images: [
      `${CDN}/products/FarmRaisedTilapiaFilletscopy.png?v=1665879208&width=800`,
      `${CDN}/products/ScreenShot2022-10-15at5.10.14PM.png?v=1665879209&width=800`,
      `${CDN}/products/tilapia.jpg?v=1665879209&width=800`,
    ],
    desc: 'Clean, white-flesh tilapia fillets from farm raised sources. Individually frozen, trimmed, and packed under strict QC. Consistent sizing and quality for high-volume food service operations.',
    pack: [
      { label: 'Pack Size', value: '10 lb / vacuum bag' },
      { label: 'Net Weight', value: '20 lb / case' },
      { label: 'Fillet Size', value: '3–5 oz · 5–7 oz · 7–9 oz' },
    ],
    priceNote: 'Wholesale pricing available on request — minimum pallet orders',
    specs: [
      { label: 'Origin', value: 'Asia' },
      { label: 'Processing', value: 'Farm Raised, Filleted, IQF' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'salmon-fillet': {
    category: 'Fish',
    name: 'Fresh Salmon Fillet',
    images: [
      `${CDN}/products/salmonfillet2.jpg?v=1665908599&width=800`,
      `${CDN}/products/salmonfillet3.jpg?v=1665908599&width=800`,
      `${CDN}/products/salmonfillet4.jpg?v=1665908598&width=800`,
    ],
    desc: 'High-quality Atlantic salmon fillets. Both fresh and frozen options available. Consistent quality and sizing for restaurant kitchens and retail seafood markets.',
    pack: [
      { label: 'Pack Size', value: '10 lb / vacuum bag' },
      { label: 'Net Weight', value: '20 lb / case' },
      { label: 'Pricing', value: 'Contact for Quote' },
    ],
    priceNote: 'Wholesale pricing available on request — fresh & frozen options',
    specs: [
      { label: 'Type', value: 'Atlantic Salmon' },
      { label: 'Processing', value: 'Filleted, Fresh and Frozen options' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
  'salmon-head': {
    category: 'Fish',
    name: 'Frozen Atlantic Salmon Head',
    images: [
      `${CDN}/products/SalmonHead.jpg?v=1665885423&width=800`,
      `${CDN}/products/SalmonHead2.jpg?v=1665885423&width=800`,
      `${CDN}/products/SalmonHead.png?v=1665885423&width=800`,
    ],
    desc: 'Frozen Atlantic salmon heads. Popular in Asian cuisine restaurants and seafood processors. Packed in bulk for wholesale. Consistent sizing and freshness.',
    pack: [
      { label: 'Pack Size', value: 'Bulk / case' },
      { label: 'Net Weight', value: '20 lb / case' },
      { label: 'Pricing', value: 'Contact for Quote' },
    ],
    priceNote: 'Wholesale pricing available on request — bulk pallet orders',
    specs: [
      { label: 'Type', value: 'Atlantic Salmon' },
      { label: 'Processing', value: 'Frozen, Wholesale Bulk Pack' },
      { label: 'Pack', value: 'Nature Fresh Branded Boxes' },
    ],
  },
};

// ─── CATALOGUE GRID (store.html) ────────────
(function () {
  const grid = document.getElementById('products-grid');
  if (!grid) return;

  const searchInput = document.getElementById('product-search');
  const filterBar = document.getElementById('category-filters');
  const emptyMsg = document.getElementById('catalogue-empty');

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const entries = Object.entries(PRODUCTS);

  // Build category filter chips from the product data.
  const categories = [...new Set(entries.map(([, p]) => p.category))];
  filterBar.insertAdjacentHTML('beforeend', categories.map((c) =>
    `<button type="button" class="filter-btn" data-category="${esc(c)}">${esc(c)}</button>`
  ).join(''));

  let activeCategory = 'all';

  const cardHTML = ([slug, p], i) => `
    <a class="product-card-full reveal" style="--reveal-delay:${i * 45}ms" href="/pages/product-detail?id=${encodeURIComponent(slug)}">
      <div class="product-card-img">
        ${p.badge ? `<span class="product-badge${p.badge.gold ? ' gold' : ''}">${esc(p.badge.text)}</span>` : ''}
        <img src="${esc(p.images[0])}" alt="${esc(p.name)}" loading="lazy" />
      </div>
      <div class="product-card-body">
        <span class="product-category-tag">${esc(p.category)}</span>
        <h3 class="product-card-name">${esc(p.name)}</h3>
      </div>
    </a>
  `;

  function render() {
    const query = searchInput.value.trim().toLowerCase();
    const filtered = entries.filter(([, p]) =>
      (activeCategory === 'all' || p.category === activeCategory) &&
      (!query || p.name.toLowerCase().includes(query) || p.category.toLowerCase().includes(query))
    );

    grid.innerHTML = filtered.map(cardHTML).join('');
    grid.hidden = filtered.length === 0;
    emptyMsg.hidden = filtered.length !== 0;
    // Newly injected cards start hidden — hand them to the reveal observer
    window.__revealScan?.();
  }

  searchInput.addEventListener('input', render);

  filterBar.addEventListener('click', (e) => {
    const btn = e.target.closest('.filter-btn');
    if (!btn) return;
    filterBar.querySelector('.filter-btn.active')?.classList.remove('active');
    btn.classList.add('active');
    activeCategory = btn.dataset.category;
    render();
  });

  render();
})();

// ─── RENDER ──────────────────────────
(function () {
  const id = new URLSearchParams(location.search).get('id');
  const p = id && PRODUCTS[id];
  const root = document.getElementById('product-root');
  if (!root) return;

  if (!p) {
    root.innerHTML =
      '<div class="product-missing">' +
      '<h1>Product not found</h1>' +
      '<p>We couldn\'t find that product. Browse the full catalogue instead.</p>' +
      '<a href="/pages/store" class="btn btn-primary">View All Products</a>' +
      '</div>';
    return;
  }

  document.title = `${p.name} — Seafresh Trading`;
  const metaDesc = document.querySelector('meta[name="description"]');
  if (metaDesc) metaDesc.setAttribute('content', p.desc);

  const esc = (s) => String(s).replace(/[&<>"]/g, (c) =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));

  const thumbs = p.images.length > 1
    ? `<div class="gallery-thumbs">${p.images.map((src, i) =>
        `<button class="gallery-thumb${i === 0 ? ' active' : ''}" data-src="${esc(src)}" aria-label="View image ${i + 1}"><img src="${esc(src)}" alt="" loading="lazy" /></button>`
      ).join('')}</div>`
    : '';

  const badge = p.badge
    ? `<span class="product-badge${p.badge.gold ? ' gold' : ''}">${esc(p.badge.text)}</span>`
    : '';

  const packHtml = p.pack.map((d, i) =>
    `${i ? '<div class="pack-divider"></div>' : ''}` +
    `<div class="pack-detail"><span class="pack-detail-label">${esc(d.label)}</span><span class="pack-detail-value">${esc(d.value)}</span></div>`
  ).join('');

  const specsHtml = p.specs.map((s) =>
    `<li><strong>${esc(s.label)}:</strong> ${esc(s.value)}</li>`).join('');

  const quoteHref = `/pages/contact?product=${encodeURIComponent(id)}`;

  root.innerHTML = `
    <nav class="breadcrumb" aria-label="Breadcrumb">
      <a href="/">Home</a><span>/</span>
      <a href="/pages/store">Products</a><span>/</span>
      <span aria-current="page">${esc(p.name)}</span>
    </nav>

    <div class="product-layout">
      <div class="product-gallery reveal">
        <div class="gallery-main">
          ${badge}
          <img id="gallery-img" src="${esc(p.images[0])}" alt="${esc(p.name)}" />
          ${p.images.length > 1 ? `
          <button type="button" class="gallery-arrow gallery-arrow-prev" aria-label="Previous image">&#8249;</button>
          <button type="button" class="gallery-arrow gallery-arrow-next" aria-label="Next image">&#8250;</button>
          ` : ''}
        </div>
        ${thumbs}
      </div>

      <div class="product-summary reveal stagger-2">
        <span class="product-category-tag">${esc(p.category)}</span>
        <h1 class="product-detail-name">${esc(p.name)}</h1>

        <div class="product-price">
          <span class="price-value">Price on request</span>
          <span class="price-tag">B2B Wholesale</span>
        </div>

        <p class="product-detail-desc">${esc(p.desc)}</p>

        <div class="product-pack-info">${packHtml}</div>
        <p class="pack-price-note">${esc(p.priceNote)}</p>

        <div class="buy-controls">
          <div class="qty-stepper" role="group" aria-label="Quantity in cases">
            <button type="button" class="qty-btn" data-step="-1" aria-label="Decrease quantity">−</button>
            <input id="qty-input" class="qty-input" type="number" value="1" min="1" inputmode="numeric" aria-label="Quantity (cases)" />
            <button type="button" class="qty-btn" data-step="1" aria-label="Increase quantity">+</button>
          </div>
          <a id="quote-btn" href="${quoteHref}" class="btn btn-primary buy-btn">Request a Quote</a>
        </div>
        <p class="buy-hint">Minimum pallet orders — quantity in cases. We'll confirm availability and pricing.</p>

        <ul class="product-specs">${specsHtml}</ul>
      </div>
    </div>

    <div class="product-cta reveal">
      <div class="product-cta-inner">
        <h3>Need this in a specific grade or size?</h3>
        <p>We source from close to a dozen producing countries. Tell us your requirements and we'll match the right product to your business.</p>
        <a href="/pages/store" class="btn btn-outline">Back to Catalogue</a>
      </div>
    </div>
  `;

  // Gallery: thumbnails + prev/next arrows share one index
  const mainImg = document.getElementById('gallery-img');
  const thumbEls = [...root.querySelectorAll('.gallery-thumb')];
  let galleryIndex = 0;
  const showImage = (i) => {
    galleryIndex = (i + p.images.length) % p.images.length;
    mainImg.src = p.images[galleryIndex];
    thumbEls.forEach((t, ti) => t.classList.toggle('active', ti === galleryIndex));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && mainImg.animate) {
      mainImg.animate(
        [{ opacity: 0.3, transform: 'scale(0.985)' }, { opacity: 1, transform: 'scale(1)' }],
        { duration: 380, easing: 'cubic-bezier(0.16, 1, 0.3, 1)' }
      );
    }
  };
  thumbEls.forEach((t, i) => t.addEventListener('click', () => showImage(i)));
  root.querySelector('.gallery-arrow-prev')?.addEventListener('click', () => showImage(galleryIndex - 1));
  root.querySelector('.gallery-arrow-next')?.addEventListener('click', () => showImage(galleryIndex + 1));

  // Quantity stepper — clamp to min 1, carry into quote link
  const qty = document.getElementById('qty-input');
  const quoteBtn = document.getElementById('quote-btn');
  const syncQuote = () => {
    let n = parseInt(qty.value, 10);
    if (!Number.isFinite(n) || n < 1) n = 1;
    qty.value = n;
    quoteBtn.href = `${quoteHref}&qty=${n}`;
  };
  root.querySelectorAll('.qty-btn').forEach((b) => {
    b.addEventListener('click', () => {
      qty.value = (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.step, 10);
      syncQuote();
    });
  });
  qty.addEventListener('change', syncQuote);
  syncQuote();
})();
